// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip {
  background-color: var(--dark-color-main);
  border-radius: 50%;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Chip.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EACA,kBAAA;EACA,YAAA;AACF","sourcesContent":[".chip {\r\n  background-color: var(--dark-color-main);\r\n  border-radius: 50%;\r\n  border: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
